import React, { Component } from 'react';
import { getQueryString } from 'utils';

import { global } from 'config';

export default class Children extends Component {
    constructor(props) {
        super(props);

        this.state = {
            type: getQueryString('type')
        }
    }

    setName = () => {
        const { type } = this.state;
		
		if (!type) {
			//return '呼呼收音机'
			let url = 'http://a.huhustory.com/Stat/watch/huawei/children.html'
			window.location.href = url;		
		} else {
			//return name[type]
			let url = 'http://a.huhustory.com/Stat/watch/huawei/privacy_etxgs.html'
			window.location.href = url;	
		}		

        let name = {
            'etxgs': '儿童学古诗',
            'etxcy': '儿童学成语',
            'yyqmeg': '英语启蒙儿歌',
            'klxcy': '快乐学成语',
            'cygs': '成语故事',
            'nppxgshd': '奶泡泡学古诗HD',             
        }
        // console.log(name[type]);

        if (!type) {
            return '呼呼收音机'
        } else {
            return name[type]
        }
    }

    setUrl = () => {
        const { type } = this.state;

        let url = {
            'etxgs': 'https://m.huhustory.com/?source=etxgs',
            'etxcy': 'https://m.huhustory.com/?source=etxcy',
            'yyqmeg': 'https://m.huhustory.com/etxeg',
        }
        // console.log(name[type]);

        if (!type) {
            return 'https://m.huhustory.com'
        } else {
            return url[type]
        }
    }

    handleComplaint = (type) => {
        window.location.href = global.href + "simple/complaint?type=" + type
    }

    handlePrivacy = (type) => {
        window.location.href = global.href + "simple/privacy?type=" + type
    }

    render() {
        const { type } = this.state;

        return (<div>

            <h3 style={{
                textAlign: 'center',
                fontWeight: 'bold',
                margin: '50px 0 20px',
                fontFamily: '宋体',
                color: '#000'
            }}>{this.setName()}儿童个人信息保护规则及监护人须知</h3>
            <div style={{
                marginBottom: "20px",
                fontSize: '14px',
                fontFamily: '宋体',
                padding: '0 15px',
                color: '#000'
            }}>

更新日期：2022年8月30日<br />		
			生效日期：2022年8月30日<br /><br />
			
			【前言】欢迎使用“{this.setName()}”（指呼呼收音机网站及其客户端程序、移动应用产品、小程序，以下称“呼呼收音机”）提供的服务！我们深知儿童（指未满十四周岁的未成年人，下同）个人信息和隐私安全的重要性，并庄严承诺保护使用呼呼收音机之儿童用户的个人信息及隐私安全。我们希望通过《呼呼收音机儿童个人信息保护规则及监护人须知》（以下简称&nbsp;“本政策”）说明我们在收集和使用儿童个人信息时对应的处理规则等相关事宜。在使用呼呼收音机前，请儿童、儿童的父母或其他监护人（以下统称“监护人”）务必仔细阅读并透彻理解本政策，特别是以粗体标识的条款应重点阅读，在确认充分理解并同意全部条款后再开始使用。<br /><br />
			
			监护人特别说明：<br />
			若我们获悉您的孩子不满十四周岁，我们将根据本政策采取特殊措施保护我们获得的您孩子的个人信息。请帮助我们保护您孩子的个人信息和隐私安全，要求他们在您的监护下共同阅读并接受本政策，且应在您的同意和指导下使用呼呼收音机、提交个人信息。如果您不同意本政策的内容，将可能导致我们的产品和服务无法正常运行，或者无法达到我们拟达到的服务效果，您应要求您的孩子立即停止访问/使用呼呼收音机。您点击同意本政策，或者您的孩子使用/继续使用呼呼收音机、提交个人信息，都表示您同意我们按照本政策（包括更新版本）收集、使用、处理您孩子的个人信息。<br /><br />			
			儿童特别说明：<br />
			我们建议：任何儿童参加网上活动都应事先取得监护人的同意。如果您是儿童，请通知您的监护人共同阅读本政策，并在您使用呼呼收音机、提交个人信息之前，寻求您的监护人的同意和指导。您点击同意本政策，或者您使用/继续使用呼呼收音机、提交个人信息，都表示您已获得您的监护人的许可，您的监护人均同意我们按照本政策（包括更新版本）收集、使用、处理您的个人信息。<br /><br />
			
			本政策适用于我们在中华人民共和国境内通过网络从事收集、使用、处理儿童个人信息等活动。当儿童使用任何呼呼收音机时，监护人同意接受本政策。如本政策与<strong><a
						class="huhu" href="http://m1.huhustory.com/simple/privacy"
						target="_blank">《呼呼收音机隐私政策》</a></strong><strong><a class="huhu"
						href="http://m1.huhustory.com/simple/user"
						target="_blank">《呼呼收音机用户协议</a>》</strong>的同类条款之约定存在不一致的，以本政策为准。如我们提供的某一单项服务不适用本政策的，该服务中会以适当方式明示排除适用本政策。本政策未尽事宜，则以<strong><a
						class="huhu" href="http://m1.huhustory.com/simple/privacy"
						target="_blank">《呼呼收音机隐私政策》</a></strong>为准。
			在阅读完本政策后，如对本政策或与本政策相关的事宜有任何问题，可通过本政策<a class="huhu"
						href="#h-7">“如何联系我们”</a>章节所列的反馈渠道联系我们，我们会尽快作出解答。<br /><br />
			本政策将帮助您了解以下内容<br />
			一、我们如何收集和使用儿童个人信息<br />
			二、我们可能处理的儿童个人信息<br />
			三、我们如何保护儿童个人信息<br />
			四、如何管理儿童个人信息<br />
			五、本政策的修订<br />
			六、如何联系我们<br /><br />
			一、我们如何收集和使用儿童个人信息<br />
			（一）我们会严格履行法律法规规定的儿童个人信息保护义务与责任，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，在征得监护人的同意后收集和使用儿童个人信息：<br />
			1、在部分单项服务中，我们可能会要求用户填写个人生日信息或根据用户填写的身份信息，识别该用户是否为儿童，并按照法律法规的规定，在获得监护人同意之后才允许儿童继续使用相关呼呼收音机服务。<br />
			2、当我们识别出用户为儿童时，我们可能会收集监护人的联系方式（例如手机号码、电子邮箱），并联系监护人以验证其与儿童的监护关系。为了更好地保护儿童的权益，我们还可能向监护人收集更多信息（例如姓名、身份证、户口本或其他监护关系证明），以便进一步验证监护人与儿童的监护关系。<br />
			3、在儿童使用呼呼收音机服务过程中，我们可能还会收集和使用其他儿童个人信息，具体请查阅<strong><a class="huhu"
						href="http://m1.huhustory.com/simple/privacy"
						target="_blank">《呼呼收音机隐私政策》</a></strong>“我们如何收集和使用您的个人信息”章节进行详细了解。如我们需要超出上述范围收集和使用儿童个人信息，我们将再次征得监护人的同意。<br /><br />
			
			（二）征得授权同意的例外<br />
			根据相关法律法规规定，以下情形中收集儿童的信息无需征得儿童和/或监护人的授权同意：<br />
			（1）与国家安全、国防安全、公共安全、公共卫生、重大公共利益直接相关的；<br />
			（2）与刑事侦查、起诉、审判和判决执行等直接相关的；<br />
			（3）出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到监护人本人同意的；<br />
			（4）所收集的信息是儿童或监护人自行向社会公众公开的；<br />
			（5）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；<br />
			（6）根据监护人的要求签订合同所必需的；<br />
			（7）通过计算机信息系统自动留存处理信息且无法识别所留存处理的信息属于儿童个人信息的；<br />
			（8）法律法规规定的其他情形。<br /><br />
			（三）有关个人敏感信息的提示<br />
			儿童的个人信息属于敏感个人信息。请监护人和儿童谨慎并留意儿童敏感个人信息，监护人同意儿童相关敏感个人信息我们可以按本政策所述的目的和方式来处理。<br /><br />
			
			二、我们可能处理的儿童个人信息<br />
			（一）一般情况下，我们不会与我们之外的第三方共享儿童的个人信息。除非满足下列条件，且征得监护人同意的，我们才会与第三方共享儿童信息；如果我们与第三方共享儿童信息，我们将进行安全评估，并与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理信息，同时我们也会采用加密、匿名化、去标识化处理等手段保障儿童的信息安全：<br />			
			1. 向儿童提供我们的服务，我们可能向合作伙伴及其他第三方共享儿童的信息。例如：向物流服务商提供对应的订单信息；向实名认证服务商提供实名认证所需资料；<br />
			2. 实现本政策第一条“我们如何收集和使用儿童个人信息”部分所述目的；<br />
			3. 履行我们在本政策或我们与儿童、监护人达成的其他协议中的义务和行使我们的权利；<br />
			4. 在法律法规允许的范围内，为了遵守法律、维护我们及我们的关联方或合作伙伴、儿童、监护人或社会公众利益、财产或安全免遭损害，比如为防止欺诈等违法活动和减少信用风险，我们可能与其他公司和组织交换信息。不过，这并不包括违反本政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的信息；<br />
			5. 应儿童合法需求或经监护人的授权同意；<br />
			6. 应监护人合法要求；<br />
			7. 根据单项服务协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；<br />
			8. 基于符合法律法规的社会公共利益而提供。<br /><br />
			（二）转让<br />
			1、随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而儿童的信息有可能作为此类交易的一部分而被转移。我们会进行安全评估，并要求新的持有儿童个人信息的公司、组织继续受本政策的约束，否则，我们将要求该公司、组织重新向监护人征求授权同意。<br />			
			2、在获得监护人的同意后，我们会向其他方转让儿童个人信息。<br /><br />
			（三）披露<br />
			我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会披露儿童个人信息：<br />
			1、根据儿童或监护人的需求，在监护人同意的披露方式下披露其所指定的信息；<br />
			2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供儿童信息的情况下，我们可能会依据所要求的信息类型和披露方式披露儿童的信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。<br /><br />			
			（四）共享、转让、披露信息时事先征得授权同意的例外<br />
			以下情形中，共享、转让、披露儿童的信息无需事先征得监护人的授权同意：<br />
			1、与国家安全、国防安全直接相关的；<br />
			2、与公共安全、公共卫生、重大公共利益直接相关的；<br />
			3、与刑事侦查、起诉、审判和判决执行等司法或行政执法直接相关的；<br />
			4、出于维护儿童或其他个人的生命、财产等重大合法权益但又很难得到监护人同意的；<br />
			5、儿童或监护人自行向社会公众公开的信息；<br />
			6、从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；<br />
			7、与我们履行法律法规规定的义务相关的。<br />
			根据法律规定，共享、转让、披露经匿名化处理的个人信息，且确保数据接收方无法复原并重新识别信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向监护人通知并征得监护人的同意。<br /><br />
			
			三、我们如何存储和保护儿童个人信息<br />
			（一）除法律法规或监管部门另有规定外，我们仅在本政策所述目的所必需且最短时限内存储儿童个人信息。如我们终止服务或运营，我们将及时停止继续收集儿童个人信息的活动，同时会遵守相关法律法规要求提前向监护人通知，并在终止服务或运营后对儿童的个人信息进行删除或匿名化处理，但法律法规或监管部门另有规定的除外。<br /><br />
			
			（二）我们非常重视儿童的隐私安全，成立了专门的安全团队，并采取一切合理可行的措施，保护儿童个人信息：<br />
			我们会采取加密等技术措施存储儿童个人信息，确保信息安全。同时，我们对工作人员以最小授权为原则，严格设定信息访问权限，控制儿童个人信息知悉范围；工作人员访问儿童个人信息的，须经过儿童个人信息保护负责人或者其授权的管理人员审批，记录访问情况，并采取技术措施，避免违法复制、下载儿童个人信息。如我们发现儿童个人信息发生或者可能发生泄露、毁损、丢失的，会立即启动应急预案，采取补救措施，并将事件相关情况以邮件、信函、电话、推送通知、公告等方式告知受影响的监护人和儿童。<br />
			
			如您希望了解更多，请查阅<strong><a class="huhu" href="http://m1.huhustory.com/simple/privacy"
						target="_blank">《呼呼收音机隐私政策》</a></strong>，“我们如何保存和保护您的个人信息”章节，详细了解我们如何存储和保护儿童个人信息。<br />
			由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。监护人需要了解，儿童接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。<br />
			
			请监护人和儿童务必妥善保管好呼呼收音机账号、密码及其他身份要素。儿童在使用我们的服务时，我们会通过账号、密码及及其他身份要素来识别其身份。一旦监护人和儿童泄露了前述信息，可能会蒙受损失，并可能对自身产生不利影响。如监护人和儿童发现账号、密码及/或其他身份要素可能或已经泄露时，请立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。<br /><br />
			
			四、如何管理儿童个人信息<br />
			在儿童使用呼呼收音机服务期间，我们将在我们的单项服务中采取适当的操作设置、指引或提供本政策“如何联系我们”章节所列的联系渠道，尽可能保证监护人和儿童可以访问、更正、删除儿童个人信息，以及注销儿童注册帐号。在访问、更正、删除前述信息或申请注销帐号时，我们可能会要求监护人和/或儿童进行身份验证，以保障信息安全。除法律法规另有规定，当监护人和儿童更正、删除儿童个人信息或申请注销帐号时，我们可能不会立即从备份系统中更正或删除相应的信息，但会在备份更新时更正或删除这些信息。<br />
			
			（一）访问儿童个人信息<br />
			监护人和儿童可以查看其在使用呼呼收音机服务中提供或产生的儿童个人信息，例如个人信息资料、部分使用记录、发布内容。<br /><br />
			（二）更正儿童个人信息<br />
			我们鼓励监护人和儿童更新和修改儿童个人信息以使其更准确有效。监护人和儿童发现我们收集、使用和处理的儿童个人信息有错误的，可以联系我们更正。我们会在完成身份验证和核实问题后，及时采取措施予以更正。<br /><br />
			（三）删除儿童个人信息<br />
			根据儿童选择呼呼收音机服务的具体情况，监护人和儿童可以在使用呼呼收音机服务中自行删除部分儿童个人信息。在以下情形下，监护人和儿童可以直接向我们提出删除儿童个人信息的请求，我们会在完成身份验证和核实问题后及时采取措施予以删除，包括：<br />			
			1、我们违反法律法规的规定或者与监护人和儿童的约定收集、存储、使用、转移、披露儿童个人信息的；<br />
			2、超出目的范围或者必要期限收集、存储、使用、转移、披露儿童个人信息的；<br />
			3、监护人撤回同意的；<br />
			4、监护人或儿童通过注销等方式终止使用呼呼收音机服务的。<br /><br />
			但请注意，若监护人和儿童自行删除或请求我们删除特定的儿童个人信息，可能导致无法继续使用全部或部分呼呼收音机服务。<br /><br />
			（四）注销帐号<br />
			在符合呼呼收音机服务单项服务协议约定条件及相关法律法规规定的情况下，我们也提供注册帐号的注销，监护人和儿童可以按照单项服务的具体设置、指引进行操作或联系我们处理。<br /><br />
			（五）改变授权同意的范围<br />
			监护人和儿童总是可以选择是否披露信息。有些信息是使用呼呼收音机服务所必需的，但大多数其他信息的提供是自行决定的。监护人和儿童可以通过删除信息、关闭设备功能等方式改变其授权我们继续收集信息的范围或撤回其授权。<br /><br />
			
			当监护人和儿童撤回授权后，我们无法继续提供撤回授权所对应的服务，也不再处理相应的信息。但撤回授权的决定，不会影响此前基于监护人和儿童的授权而开展的信息处理。<br /><br />
			（六）个人信息副本获取<br />
			如需要获取儿童的个人信息的副本，监护人和儿童可以通过本政策“如何联系我们”章节所列的反馈渠道联系我们，在核实身份后，我们将提供儿童在我们的服务中的个人信息副本(包括基本资料、身份信息)，但法律法规另有规定的或本政策另有约定的除外。<br /><br />
			
			
			五、本政策的修订<br />
			为了提供更好的服务，我们可能会根据产品或服务的更新情况及法律法规的相关要求适时修改本政策的条款，该等修改构成本政策的一部分。如该等更新造成监护人和儿童在本政策下权利的实质减少或重大变更，我们将在本政策生效前通过网站公告、推送通知、弹窗提示或其他方式来通知，监护人如果不同意该等变更，可以选择停止使用我们的服务。<br /><br />			
			我们的任何修改都会将用户的满意度置于首位。我们鼓励监护人和儿童在每次使用我们的服务时都查阅我们的《儿童个人信息保护规则及监护人须知》。<br /><br />
			六、如何联系我们<br />
			杭州叽里咕噜文化传播有限公司将按照本政策保护儿童个人信息。我们设有个人信息保护专职部门并指定了专门的儿童个人信息保护负责人。如监护人和儿童有关于网络信息安全的投诉和举报，或对本政策、呼呼收音机儿童个人信息保护规则、措施的相关事宜有任何问题、意见或建议，请随时与我们联系，可发送邮件至huhu@hezi.com<br /><br />
				
			一般情况下，我们将在收到您的问题、意见或建议，并验证您的用户身份后的十五个工作日内予以处理。如您不满意我们的处理，您还可以向履行个人信息保护职责的部门进行投诉、举报。

            </div>
        </div>);
    }
}